import {UsersInitialState} from '../states';
import * as Actions from './actions';

const usersReducer = (state = UsersInitialState, action) => {
    switch(action.type) {
        case Actions.SET_USERS_POOL:
            return {...state, poolList: {...action.payload}};
        case Actions.SET_USERS_PERSONAL_LIST:
            return {...state, personalList: {...action.payload}};
        default:
            return {...state}
    }
}
  
export default usersReducer;